module.exports = __webpack_public_path__ + "static/desktop/img/material-mobile-calendar-1.e1d1d8f1.png";